import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  I18n,
  Icon,
} from 'components';

import { formatDate } from '../../common';

import {
  ATTACHMENT_URL,
  FILE_TYPES,
} from '../../constants';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const getAttachmentUrl = (id) => `${ATTACHMENT_URL}?requestId=${id}`;

const Attachment = ({
  id,
  type,
  title,
  dateFrom,
  dateTo,
}) => {
  if (FILE_TYPES.indexOf(type) === -1) {
    return null;
  }

  return (
    <div className={cx('container')}>
      <div>
        <I18n
          path="messages.attachmentTitle"
          vars={{
            title,
            from: formatDate(dateFrom),
            to: formatDate(dateTo),
          }}
        />
      </div>
      <div className={cx('download')}>
        <a href={getAttachmentUrl(id)}>
          <Icon className={cx('attachmentIcon')} name={type} />
          <I18n path="messages.download" />
        </a>
      </div>
    </div>
  );
};

Attachment.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  dateFrom: PropTypes.string,
  dateTo: PropTypes.string,
  id: PropTypes.number,
};

export default Attachment;
